import { Component } from '@angular/core';
import { SegovSigepoPortalBodyComponent } from '../../controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';

@Component({
  selector: 'app-erro-nao-encontrado-page',
  standalone: true,
  imports: [SegovSigepoPortalBodyComponent],
  templateUrl: './erro-nao-encontrado-page.component.html',
  styleUrl: './erro-nao-encontrado-page.component.css'
})
export class ErroNaoEncontradoPageComponent {

}
